import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { uploadEventAttachment } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Event attachments cannot be uploaded, please try again later.');
};

type UploadEventAttachmentParams = {
  eventId: string;
  file: Blob;
};

export const useUploadEventAttachmentMutation = () =>
  useMutation<unknown, UploadEventAttachmentParams>({
    defaultMutateOnError,
    async mutationFn({ eventId, file }) {
      const formData = new FormData();
      formData.append('file', file);

      await uploadEventAttachment({
        body: { formData },
        routeParams: { eventId },
      });
    },
  });
